import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-switch",
  "use": "icon-switch-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-switch\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M9.3,5.37l.94.94L8.55,8H18V9.33H8.55L10.24,11,9.3,12,6,8.67ZM14.7,12l3.3,3.3-3.3,3.3-.94-.94L15.45,16H6V14.67h9.45L13.76,13Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol